import React from 'react';
import { toTitleCase } from '../../../../utils/index';
import tableStyles from '../../../../utils/ShowPreview.module.scss';
import BitaButton from '../../../../../../bitaComponents/BitaButton/BitaButton';

const BasketErrorsTable = ({ errorRows, onGoFix }) => {
  const rows = Array.isArray(errorRows) ? errorRows : [];
  if (rows.length === 0) {
    return <div className={tableStyles.noData}>No errors found</div>;
  }

  const handleGoFix = (module, property) => {
    if (onGoFix) {
      onGoFix(module, property);
    }
  };

  return (
    <div className={tableStyles.container}>
      <table className={tableStyles.table}>
        <thead className={tableStyles.thead}>
          <tr>
            <th className={tableStyles.th}>
              <div className={tableStyles.thContent}>Module</div>
            </th>
            <th className={tableStyles.th}>
              <div className={tableStyles.thContent}>Property</div>
            </th>
            <th className={tableStyles.th}>
              <div className={tableStyles.thContent}>Error</div>
            </th>
            <th className={tableStyles.th}>
              <div className={tableStyles.thContent} />
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map(({ module, property, message }) => (
            <tr key={`${module}-${property}-${message ?? ''}`} className={tableStyles.tableRow}>
              <td className={tableStyles.td}>{toTitleCase(module)}</td>
              <td className={tableStyles.td}>{toTitleCase(property)}</td>
              <td className={tableStyles.td}>{message || '-'}</td>
              <td className={tableStyles.td}>
                <BitaButton
                  className={tableStyles.goFixButton}
                  width="auto"
                  onClick={() => handleGoFix(module, property)}
                >
                  Go Fix
                </BitaButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BasketErrorsTable;
